export default store => {
  return {
    async getPlaylists(params) {
      return await store.dispatch(`playlists/fetch`, {
        params
      });
    },
    async getPlaylist(params) {
      return await store.dispatch(`playlists/fetch`, {
        type: "playlist",
        params
      });
    }
  };
};
